import flatpickr from "flatpickr"

const DateTimePicker = {
  init: () => {
    DateTimePicker.configure()
    DateTimePicker.initFlatpickr()
  },
  configure: () => {
    // https://flatpickr.js.org/options/
    const defaultConfig = {
      allowInput: true,
      defaultHour: 0,
      enableTime: true,
      enableSeconds: true,
      onChange: DateTimePicker.onDateTimeChange,
      shorthandCurrentMonth: true,
      showMonths: 2,
      time_24hr: true,
    }
    const configs = {
      date_time_range: {
        ...defaultConfig,
        mode: "range",
        dateFormat: "d/m/Y H:i:S",
        monthSelectorType: "static",
        showClearButton: true,
      },
      single_date_time: {
        ...defaultConfig,
        mode: "single",
        dateFormat: "d/m/Y H:i",
        minDate: new Date(new Date().setHours(0, 0, 0, 0)),
        monthSelectorType: "dropdown",
      },
      single_date_no_time: {
        ...defaultConfig,
        mode: "single",
        enableTime: false,
        dateFormat: "d/m/Y",
        minDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        monthSelectorType: "dropdown",
      },
    }

    configs.single_optional_date_time = {
      ...configs.single_date_time,
      showClearButton: true,
    }

    configs.single_date_no_time_no_min = {
      ...configs.single_date_no_time,
      minDate: null,
    }

    configs.single_date_time_no_min = {
      ...configs.single_date_time,
      minDate: null,
    }

    DateTimePicker.configs = configs

    // Override default range separator to match daterangepicker
    flatpickr.l10ns.default.rangeSeparator = " - "
  },
  onDateTimeChange: (selectedDates, _dateStr, instance) => {
    // Prepopulate range end time to 23:59:59.999
    if (instance.config.mode !== "range") return

    const [start, end] = selectedDates
    if (!end) {
      instance.endDateEdited = false // reset when end date cleared
      return
    }
    if (instance.endDateEdited) return

    end.setHours(23, 59, 59, 999)
    instance.endDateEdited = true
    instance.setDate([start, end])
  },
  initFlatpickr: () => {
    $("input.date_range_picker").each((_index, input) => {
      const type = $(input).data("picker-type") || "date_time_range"
      const minDate = $(input).data("minDate")
      const options = minDate
        ? { ...DateTimePicker.configs[type], minDate: flatpickr.parseDate(minDate, "Y-m-d") }
        : DateTimePicker.configs[type]
      // Prepopulate with today when required (eg matures_at)
      if (input.required && !input.value && !type.includes("no_min")) {
        options.defaultDate = new Date(new Date().setHours(0, 0, 0, 0))
      }
      if ($(input).data("format")) {
        options.dateFormat = $(input).data("format")
      }
      let fp
      if (options.showClearButton) {
        const wrapper = $(input).closest(".input-group.date.form_datetime")
        wrapper.append("<a class='input-group-addon input-group-append border' data-clear>Clear</a>")
        options.wrap = true
        input.dataset.input = ""
        fp = flatpickr(wrapper, options)
      } else {
        fp = flatpickr(input, options)
      }
      // Set data-qa for tests
      if (fp.altInput) {
        if (input.dataset.qa) fp.altInput.dataset.qa = input.dataset.qa
        if (input.id) fp.altInput.dataset.id = input.id
      }
      $(input).attr("autocomplete", "off")
    })
  },
}

document.addEventListener("DOMContentLoaded", () => {
  DateTimePicker.init()
})
